import React from 'react';
import { RouteListType } from 'src/utils/routing';
import { createRoute } from 'src/utils/routing/routeFactory';

const isDevelopment = process.env.NODE_ENV === 'development';

export const Icons = createRoute({
  path: '/dev/icons',
  component: React.lazy(() => import('./pages/icons')),
});

export const devRoutes = isDevelopment
  ? ([
      {
        header: 'Development',
        routes: [Icons.routeDescriptor],
        permissions: ['CherreDev'],
      },
    ] satisfies RouteListType)
  : [];
